import { useApp } from '@/hooks/use-app-context';
import { Icon } from '@/lib/icons';
import { visitorHeaderText } from './visitor-header-copy';

export function HeaderThemeToggle() {
  const { theme, toggleTheme, language } = useApp();
  const isDark = theme === 'dark';
  const copy = visitorHeaderText(language);

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? copy.toLight : copy.toDark}
      aria-pressed={isDark}
      className="group/theme relative flex h-10 w-10 items-center justify-center rounded-full text-muted-foreground transition-colors duration-200 hover:bg-muted/60 hover:text-foreground focus-ring"
    >
      <Icon
        name={isDark ? 'sun' : 'moon'}
        className="relative h-4 w-4 transition-transform duration-200 ease-out group-hover/theme:scale-110"
      />
    </button>
  );
}
